var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "titlebar",
      style: {
        color: _vm.title_data && _vm.title_data.color,
        backgroundColor: _vm.title_data && _vm.title_data.backgroundColor
      },
      attrs: { id: "titlebar", title: _vm.title_data && _vm.title_data.title }
    },
    [_c("span", { staticClass: "back btn", on: { click: _vm.go_back } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }